import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useDataAggregation } from '../../Common/hooks/useAggregationData';
import { useCadUniqueChartsDataContext } from './hooks/useCadUniqueChartsDataContext';

export const FamiliesAnual = () => {
    const { chartData } = useCadUniqueChartsDataContext();

    const rawData = chartData?.familiesAnual || [];

    const series = [
        {
            name: 'Famílias Cadastradas',
            data: rawData.map(item => item.months?.[0]?.value ?? Number(item.value))
        }
    ];

    return (
        <SimpleBars
            title={'Evolução anual das famílias cadastradas'}
            horizontal={false}
            subtitles={rawData.map(item => getYearLabel(item.ano))}
            series={series}
            decimals={0}
        />
    );
};
